import { AccessCalendarSyncDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useAccessCalendarSync = (accessId?: number) => {
  const { data, loading } = useQuery(AccessCalendarSyncDocument, {
    variables: { accessId: Number(accessId) },
    skip: !accessId,
  })

  return {
    loading,
    accessCalendarSync: data?.cronofyScheduling.calendarSyncsConnection.nodes[0] ?? null,
  }
}
